module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Page_Break"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "normal",
      "font-size": "2.00em"
    }
  }, [_vm._v("PREFACE")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "normal",
      "font-size": "1.20em"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("The Honeywood File")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" described the building of a house, and the present volume carries the history to conclusion ten months later when the last defect has been remedied, the last dispute settled, and the last account paid.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("The aspirant to architectural practice—unlike the general reader—is more interested in building houses than in occupying them; but the proof of a pudding is in the eating, and by showing the consequences that flowed from events recorded in the earlier book, ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("The Honeywood Settlement")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" completes the lesson of ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("The Honeywood File")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("H.B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda49044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0004.vue
// module id = 69
// module chunks = 0